import React, {forwardRef} from 'react';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";
import { useTranslation } from 'react-i18next';

const Industry = forwardRef((props, ref) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // Array of industry images (1.jpg to 6.jpg)
    const industryImages = [{
        image: '/industries/1.jpg', text: t("home_page.industry.agro"), link: "/page-agro#industry"
    },
        {
            image: '/industries/2.jpg', text: t("home_page.industry.mining"), link: "/page-mining#industry"
        },
        {
            image: '/industries/3.jpg', text: t("home_page.industry.engineering"), link: "/page-engineering#industry"
        },
        {
            image: '/industries/4.jpg', text: t("home_page.industry.tourism"), link: "/page-tourism#industry"
        },
        {
            image: '/industries/5.jpg', text: t("home_page.industry.coal_chemistry"), link: "/page-coal-chemistry#industry"
        },
        {
            image: '/industries/6.jpg', text: t("home_page.industry.petrochemistry"), link: "/page-petrochemistry#industry"
        }
    ];

    return (
        <Box ref={ref}>
            <Box marginBottom={4} sx={{display: 'flex', alignItems: 'center'}}>
                <Box
                    component={Typography}
                    fontWeight={700}
                    variant={'h4'}
                >
                    {t("home_page.industry.title")}
                </Box>
            </Box>
            <Box>
                <Grid container spacing={4}>
                    {industryImages.map((obj, i) => (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                            <Link href={obj.link} style={{textDecoration: 'none'}}>
                                <Box
                                    component={Card}
                                    padding={2}
                                    borderRadius={4}
                                    width={'100%'}
                                    height={'100%'}
                                    data-aos={'fade-up'}
                                    sx={{
                                        border: '1px solid #e0e0e0',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                    }}
                                >
                                    <Box display={'flex'} flexDirection={'column'}>
                                        <img
                                            src={obj.image}
                                            alt={`Industry ${i + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '200px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                marginBottom: '16px'
                                            }}
                                        />
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                fontSize: '1.2rem',
                                                fontWeight: 500,
                                                textAlign: 'center',
                                            }}
                                        >
                                            {obj.text}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
});

export default Industry;
